<template>
    <div style="padding-top:10px">
      <div class="f-card" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
        <img v-if="item.tp" :src="item.tp" class="image" >
        <img v-else src="@images/headerDft.png" class="image" />
         <div class="content">
           <div class="flex-center">
             <span class="name">{{item.name}}</span>
             <span class="tag" v-if="item.zw">{{item.zw}}</span>
           </div>
           <div class="dw">{{item.szdw}}</div>
           <div class="dz">{{item.sysOrgCodeZhen_dictText?item.sysOrgCodeZhen_dictText:''}}{{item.sysOrgCode_dictText}}</div>
         </div>
        <div class="dhzx" @click.stop="clickDh(item.lxdh)">电话咨询</div>
        
      </div>
    </div>
</template>



<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
     showQx: {//等于1显示
      type: Boolean,
      default: false,
     },
    // 自定义返回逻辑
    clickItem: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      listData: [],
      show:false,
      obj:{},
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.listData = this.list
      },
    },
  },
  created() {},
  methods: {
    goDetail: function (e) {
        this.$router.push({
        path: '/gzfw/fzsb-view',
        query: {id:e.id},
      }) 
    },
    clickDh(dh){
      if(!dh){
       return;
      }
     window.location.href = `tel:${dh}`
    },
  },
}
</script>

<style lang="less" scoped>
  .f-card{
    margin: 0 10px 10px 10px;
    height: 95px;
    background: #FFFFFF;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding-left: 11px;
    
    .image{
      width: 68px;
      height: 68px;
      border-radius: 50%;
      margin-right: 10px;
    }
    
    .content{
      flex: 1;
      display: flex;
      flex-direction: column;
      
      .name{
        font-size: 17px;
        color: #1A1A1A;
        font-weight: bold;
      }
      
      .tag{
        margin-left: 10px;
        padding: 0 15px;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #937038;
        background-image: linear-gradient(180deg, #FFF7EA 0%, #FDECD0 100%);
        border-radius: 25px;
      }
      
      .dw{
        font-size: 14px;
        color: #1A1A1A;
        margin-bottom: 6px;
        margin-top: 6px;
      }
      
      .dz{
        font-size: 12px;
        color: #666666;
      }
    }
    
    .dhzx{
      width: 72px;
      height: 30px;
      background: #1D6DDB;
      border-radius: 15px 0 0 15px;
      text-align: center;
      color: #FFFFFF;
      line-height: 29px;
      margin-top: -17px;
      font-size: 14px;
    }
  }
  
</style>
